/**
 * Footer Menu Item Component
 *
 * Handles footer menu items with subitems:
 * - Desktop: Shows popover when clicking the trigger link (text + plus)
 * - Mobile: Shows accordion for expand/collapse
 * - CSS controls visibility based on viewport
 * - Prevents default link navigation on desktop
 */

class FooterMenuItem extends HTMLElement {
  constructor() {
    super();
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
  }

  connectedCallback() {
    // Media query for desktop detection
    this.mediaQuery = window.matchMedia('(min-width: 1024px)');

    // Add click handler to prevent navigation on desktop
    const trigger = this.querySelector('[data-footer-trigger]');
    if (trigger) {
      trigger.addEventListener('click', this.handleTriggerClick);
    }
  }

  disconnectedCallback() {
    const trigger = this.querySelector('[data-footer-trigger]');
    if (trigger) {
      trigger.removeEventListener('click', this.handleTriggerClick);
    }
  }

  /**
   * Handle trigger click - prevent navigation on desktop only
   */
  handleTriggerClick(event) {
    const isDesktop = this.mediaQuery.matches;

    if (isDesktop) {
      event.preventDefault();
      // The popover will open automatically via aria-controls
    }
  }
}

if (!window.customElements.get('footer-menu-item')) {
  window.customElements.define('footer-menu-item', FooterMenuItem);
}

/**
 * Scroll to Top Buttons
 *
 * Smooth scroll to top of page when clicked
 * Handles both mobile and desktop buttons
 */
const handleScrollToTop = () => {
  const scrollToTopButtons = document.querySelectorAll('.footer__scroll-to-top');

  if (scrollToTopButtons.length === 0) {
    return;
  }

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  scrollToTopButtons.forEach(button => {
    button.addEventListener('click', handleClick);
  });
};

// Initialize scroll to top buttons when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleScrollToTop);
} else {
  handleScrollToTop();
}
